export default __webpack_public_path__ + "static/media/mamao.774a51c4.png";